module.exports = __webpack_public_path__ + "img/home-begin-box.312ca11a.png";